import {
  makeType,
  initLog
} from '../core/base'

import {
  Stream
} from '../core/dispatcher-flyd'

import {
  modelChanged
} from './common'

import UI from '../core/ui'

const proto = {
  name: 'Carousel',

  initLog,

  init() {
    return {
      scrollLeft: 0,
      first: true,
      last: false,
      reset: false,
      initial_position: this.carousel.style.position,
      initial_left: this.carousel.style.left
    }
  },

  update(msg, model) {
    const children = [ ...this.carousel.children ].filter(
      n => n.dataset.role !== 'filler'
    )

    // this.log.warn(`event: ${msg.type}`)

    switch (msg.type) {
    case 'click': {
      const {
        target
      } = msg
      if (target.hasRole('slideshow-nav-next')) {
        const next = children.filter(
          n =>
            n.offsetLeft
            > this.carousel.scrollLeft
            + this.carousel.clientWidth
            + this.carousel.offsetLeft
        )

        if (next.length > 0) {
          model.scrollLeft = next[0].offsetLeft
        }
      }
      if (target.hasRole('slideshow-nav-previous')) {
        // this.log.warn(`1 scrollLeft:`, model.scrollLeft)
        const offset = this.carousel.scrollLeft
            - this.carousel.clientWidth
            + this.carousel.offsetLeft
        const last = children.filter(n => n.offsetLeft <= offset)
        if (last.length > 0) {
          model.scrollLeft = last[last.length - 1].offsetLeft
        } else {
          // TODO: experimental
          model.scrollLeft = children[0].offsetLeft
        }
      }
      break
    }
    case 'resize':
      model = this.carouselState(model)
      model.reset = true
      break

        // default:
        //   this.log.warn("unhandled event:", msg.type, msg);
    }

    const prev = children.filter(c => c.offsetLeft < model.scrollLeft)

    model.first = prev.length < 1

    const next = children.filter(
      c => c.offsetLeft > model.scrollLeft + this.carousel.clientWidth
    )

    model.last = next.length < 1

    return model
  },

  view(model) {
    // this.log.warn(`view called:`, { ...model })
    this.carousel.scrollLeft = model.scrollLeft - this.carousel.offsetLeft
    const cls = 'disabled'
    if (model.reset === true) {
      this.carousel.style.position = model.initial_position
      this.carousel.style.left = model.initial_left
      // this.dom.addClass("sans-controls")
      this.dom
        .findByRole('slideshow-nav-previous')
        .forEach(c => c.removeClass('invisible'))
      this.dom
        .findByRole('slideshow-nav-next')
        .forEach(c => c.removeClass('invisible'))
    }

    // this.log.warn(`view: model:`, {... model})
    // this.log.warn(`view: carousel offset:`, this.carousel.offsetLeft)
    // this.log.warn(`view: carousel clientWidth:`, this.carousel.clientWidth)

    // if (model.first === true && model.last === true) {
      // TODO: test this: causes problems
      // this.carousel.style.position = "relative"
      // this.carousel.style.left = `${0 - this.carousel.offsetLeft}px`
    // }

    this.dom.findByRole('slideshow-nav-previous').forEach(c => {
      if (model.first === true) {
        c.addClass(cls)

        if (model.last === true) {
          c.addClass('invisible')
        }
      } else {
        c.removeClass(cls)
      }
    })

    this.dom.findByRole('slideshow-nav-next').forEach(c => {
      if (model.last === true) {
        c.addClass(cls)
        if (model.first === true) {
          c.addClass('invisible')
        }
      } else {
        c.removeClass(cls)
      }
    })
    // if (model.first === true && model.last === true){
    //   console.log(`sans controls`, this.dom)
    //   this.dom.addClass(`sans_controls`)
    // }
    return model
  },

  carouselState(model) {
    const children = [ ...this.carousel.children ].filter(
      n => n.dataset.role !== 'filler'
    )

    const prev = children.filter(c => c.offsetLeft < model.scrollLeft)

    model.first = prev.length < 1

    const next = children.filter(
      c => c.offsetLeft > model.scrollLeft + this.carousel.clientWidth
    )

    model.last = next.length < 1

    return model
  },

  addFiller() {
    // return // eslint-disable-next-line no-extra-semi

    [ ...Array(10) ].map(() => {
      const c = document.createElement('div')
      c.dataset.role = 'filler'
      this.carousel.appendChild(c)
    })
  },

  initialize(slideshow) {
    this.dom = slideshow
    this.carousel = this.dom.findByRole('carousel-frame')[0]
    this.initLog()

    this.addFiller()

    let currentModel = this.init()
    // currentModel.initial_position = this.carousel.style.position
    // currentModel.initial_left = this.carousel.style.left

    currentModel = this.carouselState(currentModel)

    this.view(currentModel)

    this.eventStream = new Stream()

    this.eventStream.map(msg => {
      let model = {
        ...currentModel
      }
      model = this.update(msg, model)
      // model = this.updateControls(model);
      if (modelChanged(currentModel, model)) {
        model = this.view(model)
      } else if (this.carousel.scrollLeft < currentModel.scrollLeft) {
        // workaround problem: livevieiw rerendered carousel: reset back to initial position
        model = this.view(model)
      }
      currentModel = model
    })

    this.dom.findByRole('slideshow-nav').forEach(c => {
      if (c.hasRole('slideshow-nav-next')) {
        c.addEvent('click', this.eventStream.stream)
      }
      if (c.hasRole('slideshow-nav-previous')) {
        c.addEvent('click', this.eventStream.stream)
      }
    })

    window.addEvent('resize', this.eventStream.stream)

    this.dom.addEvent('touchstart', this.eventStream.stream)
    this.dom.addEvent('touchmove', this.eventStream.stream)
    this.dom.addEvent('touchend', this.eventStream.stream)
  }
}

const Carousel = makeType(proto)

export default Carousel

UI.register('carousel', Carousel)
